export default "__VITE_ASSET__BwumXk0$__"